import script from "./iContent.vue?vue&type=script&setup=true&lang=js"
export * from "./iContent.vue?vue&type=script&setup=true&lang=js"

import "./iContent.vue?vue&type=style&index=0&id=41dcf2aa&lang=less&scoped=true"

import exportComponent from "G:\\project\\csadmin-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41dcf2aa"]])

export default __exports__